/**
 * Сигнал соединения карусели (§7.11): два восходящих тона в момент, когда
 * абонент оказался на линии. Диспетчер слышит его В НАУШНИКЕ раньше, чем
 * успевает увидеть баннер, — и здоровается сразу, а не после паузы.
 *
 * Отдельный от бипа перезвонов (callbacks-panel): тот тревожный (880→660,
 * «пора звонить»), этот позитивный (660→880, «вы в эфире»).
 */

export function playConnectBeep(): void {
  try {
    const ctx = new AudioContext();
    void ctx.resume().catch(() => {});
    const gain = ctx.createGain();
    gain.gain.value = 0.12;
    gain.connect(ctx.destination);

    const tone = (freq: number, startMs: number, durMs: number): void => {
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.value = freq;
      osc.connect(gain);
      osc.start(ctx.currentTime + startMs / 1000);
      osc.stop(ctx.currentTime + (startMs + durMs) / 1000);
    };
    tone(660, 0, 110);
    tone(880, 130, 150);
    setTimeout(() => {
      void ctx.close().catch(() => {});
    }, 600);
  } catch {
    // Звук — удобство: без него соединение всё равно видно баннером
  }
}
